/** Shape of every paginated list returned by the API. */
export type Paginated<T> = {
  items: T[];
  pagination: { page: number; pageSize: number; total: number; totalPages: number };
};

export type ListParams = {
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  search?: string;
  [filter: string]: string | number | boolean | undefined;
};

/** Removes empty values so they are not sent as query parameters. */
export function cleanParams(params: ListParams): Record<string, string | number | boolean> {
  return Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined && value !== "" && value !== null)) as Record<string, string | number | boolean>;
}
